import { Component, Vue } from "vue-property-decorator";
import { MODULE_ID as SSO_MODULE_ID } from "../index";
import { BaseUser } from "@abaco/web-common/src/BaseUser";
import { FromStore } from "@abaco/web-common/src/app";
import { format } from "date-fns";
import BigNumber from "bignumber.js";

/**
 * @type CurrencyDiplay
 *
 */
type CurrencyDiplay = "code" | "symbol" | "narrowSymbol" | "name";

@Component
export default class Utils extends Vue {
    @FromStore(SSO_MODULE_ID) user!: BaseUser;

    /**
     * ### formattedDateOnly
     * @param {String | Number | Date} dt
     * @returns { String } return date formatted
     */
    formattedDateOnly(dt: string | number | Date): string {
        let date: Date = new Date();
        if (typeof dt === "string") {
            date = new Date(Date.parse(dt));
        }

        return format(date, this.user.dateFormat);
    }

    /**
     * ### formatCurrency
     *
     * @param {String|Number} value
     * @param {String} [currency="EUR"]
     * @param {CurrencyDiplay} [currencyDisplay="code"]
     * @returns {String} Return formatted string of currency
     *
     * ```typescript
     * this.formatCurrency("3400"); // with locale en --> EUR 34,000.00
     * ```
     */
    formatCurrency(value: string | number, currency = "EUR", currencyDisplay: CurrencyDiplay = "code"): string {
        return new Intl.NumberFormat(this.getLocale(true), { style: "currency", currency, currencyDisplay }).format(
            +value
        );
    }

    /**
     * ### formatNumber
     *
     * @param {String|Number} value
     * @param {Number} minimumFractionDigits
     * @param {Number} maximumFractionDigits
     * @returns {String} Return formatted string of currency
     *
     * ```typescript
     * this.formatNumber("3400"); // with locale en --> 34,000
     * ```
     */
    formatNumber(value: string | number, minimumFractionDigits?: number, maximumFractionDigits?: number): string {
        return new Intl.NumberFormat(this.getLocale(true), {
            minimumFractionDigits,
            maximumFractionDigits
        }).format(+value || 0);
    }

    /**
     * ### getLocale
     *
     * if iso true replace the locale from en_US to en-US;
     *
     * @param {Boolean} [iso=false]
     * @returns {String}
     *
     *
     *
     * ### Examples:
     * ```typescript
     * this.getLocale(); // return en_US
     * this.getLocale(true); // return en-US
     * ```
     */
    getLocale(iso = false): string {
        return !iso ? this.user.locale : this.user.locale.replace(/_/gi, "-");
    }

    /**
     * @param  {string} str
     * @returns string
     */
    sum(list: number[]): number {
        return list.reduce((acc, val) => acc.plus(val), new BigNumber(0)).toNumber();
    }
}
